// extracted by css-extract-rspack-plugin
export default {"root":"root-YfwBcf","documentsList":"documentsList-ngdneY","emptyStateContainer":"emptyStateContainer-j2O0nK","emptyPadding":"emptyPadding-oWXAyS"};